import { render, staticRenderFns } from "./PWmatFreeDownload.vue?vue&type=template&id=264c8a2d&scoped=true&"
import script from "./PWmatFreeDownload.vue?vue&type=script&lang=js&"
export * from "./PWmatFreeDownload.vue?vue&type=script&lang=js&"
import style0 from "./PWmatFreeDownload.vue?vue&type=style&index=0&id=264c8a2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c8a2d",
  null
  
)

export default component.exports